import { CssBaseline, GlobalStyles } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useShallow } from 'zustand/react/shallow';
import AppInsightHOC from './Components/AppInsightHOC';
import { router } from './routes';
import type { FetchError } from './services/fetch.service';
import { useStore } from './store/store';
import theme, { getLocalizationForMui, globalStyles } from './theme';

export default function App() {
  const [catalog] = useStore(useShallow(state => [state.catalog]));

  const themeWithUpdatedLanguage = createTheme(theme, { ...getLocalizationForMui(catalog?.language) });

  return (
    <AppInsightHOC>
      <ThemeProvider theme={themeWithUpdatedLanguage}>
        <CssBaseline />
        <GlobalStyles styles={globalStyles} />
        <ToastContainer toastStyle={{ fontSize: 14 }} />
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
      </ThemeProvider>
    </AppInsightHOC>
  );
}

declare module '@tanstack/react-query' {
  interface Register {
    defaultError: FetchError;
  }
}
